<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">Register</div>
          <div class="card-body">
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <form action="#" @submit.prevent="onSubmit">
              <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">Alias</label>
                <div class="col-md-6">
                  <b-input
                    id="alias"
                    type="text"
                    class="form-control"
                    name="alias"
                    :state="validation"
                    value
                    required
                    autofocus
                    v-model="form.alias"
                  />
                  <b-form-text>Your alias which is displayed to other users.</b-form-text>
                  <b-form-invalid-feedback :state="validation">
                    Your alias must be 3-30 characters long.
                  </b-form-invalid-feedback>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">Email</label>

                <div class="col-md-6">
                  <b-input
                    id="email"
                    type="email"
                    class="form-control"
                    name="email"
                    autocomplete="email"
                    value
                    required
                    autofocus
                    v-model="form.email"
                  />
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">Password</label>

                <div class="col-md-6">
                  <b-input
                    id="password"
                    type="password"
                    placeholder="Your Password"
                    autocomplete="new-password"
                    :state="passwordLength"
                    class="form-control"
                    name="password"
                    required
                    v-model="form.password"
                  />
                  <b-form-invalid-feedback :state="passwordLength">
                    password must be at least 8 characters long!
                  </b-form-invalid-feedback>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">Password (confirm)</label>

                <div class="col-md-6">
                  <b-input
                    id="password-confirm"
                    type="password"
                    placeholder="Password Confirmation"
                    autocomplete="new-password"
                    :state="checkSamePasswords"
                    class="form-control"
                    name="password"
                    required
                    v-model="form.passwordConfirm"
                  />
                  <b-form-invalid-feedback :state="checkSamePasswords">
                    passwords must match!
                  </b-form-invalid-feedback>
                </div>
              </div>

              <div class="form-group row mb-0">
                <div class="col-md-8 offset-md-4">
                  <button type="submit" class="btn btn-primary">Register</button>
                </div>
              </div>
            </form>
            <p class="has-text-grey text-center mt-3">
              <a>Sign In With Google</a>&nbsp; <router-link :to="{ name: 'login' }">Sign Up</router-link> &nbsp;·&nbsp;
              <a href="../">Need Help?</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ user: 'auth/user' }),
    validation() {
      return this.form.alias.length > 2 && this.form.alias.length < 30;
    },
    passwordLength: function(val) {
      return val.form.password.length > 7;
    },
    checkSamePasswords: function(val) {
      return val.form.passwordConfirm === this.form.password;
    },
  },
  data() {
    return {
      form: {
        alias: '',
        email: '',
        password: '',
        passwordConfirm: '',
      },
      error: null,
    };
  },
  methods: {
    onSubmit() {
      this.$store
        .dispatch('auth/register', { form: this.form })
        .then(user => {
          this.$store
            .dispatch('auth/createUserProfile', {
              uid: user.uid,
              userProfile: { alias: this.form.alias },
            })
            .then(() => {
              // all good -> redirect to home
              this.$router.push({ name: 'home' });
            })
            .catch(e => {
              this.error = e;
            });
        })
        .catch(errorMessage => {
          this.error = errorMessage;
        });
    },
  },
  created() {
    // redirect to home if already logged in
    if (this.user.loggedIn) {
      return this.$router.push({ name: 'home' });
    }
  },
};
</script>
